export default __webpack_public_path__ + "static/windbeutel-d0af147bc44fe42c50242562861defcf.jpg";